class CaseSlider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    // 施工事例　スライダー
    $('.s-top-case').slick({
      prevArrow: '<button class="slide-arrow prev-arrow"></button>',
      nextArrow: '<button class="slide-arrow next-arrow"></button>',
      autoplay: true,
      adaptiveHeight: true,
      centerMode: true,
      centerPadding: "10%",
      dots: false,
      variableWidth: true,
      pauseOnFocus: false,
      pauseOnHover: false,
    });
  }
}